import { ImportDTO, StoreImportStatusDTO } from "../types/storeImportDTOs"
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse, AxiosError } from "axios";
import Problem from "../types/problem";
import apiClient from "../main/apiClient";


const useFetchStoreImport = (organisationId: string) => {
    return useQuery<ImportDTO, AxiosError>({
        queryKey: ["storeImport"],
        queryFn: () =>
            apiClient.get(`/organisation/${organisationId}/storeimport`).then((resp) => resp.data),
    });
}

const useFetchStoreImportStatus = (organisationId: string) => {
    return useQuery<StoreImportStatusDTO, AxiosError>({
        queryKey: ["storeImportStatus", organisationId],
        queryFn: () =>
            apiClient.get(`/organisation/${organisationId}/storeimport/status`).then((resp) => resp.data),
        refetchInterval: 1000,
    });
}

const useUpdateStoreImport = (organisationId: string) => {
    const queryClient = useQueryClient();
    return useMutation<AxiosResponse, AxiosError<Problem>, ImportDTO>({
        mutationFn: (importDTO) => apiClient.post(`/organisation/${organisationId}/storeimport`, importDTO),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["storeImport"] });
            queryClient.invalidateQueries({ queryKey: ["user"] });
            queryClient.invalidateQueries({ queryKey: ["capability"] });
            queryClient.invalidateQueries({ queryKey: ["station"] });
        }
    });
};



export { useFetchStoreImport, useFetchStoreImportStatus, useUpdateStoreImport }
